var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("c-tab", {
        attrs: {
          type: "vertical",
          tabItems: _vm.tabItems,
          height: _vm.tabHeight,
        },
        on: {
          "update:height": function ($event) {
            _vm.tabHeight = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (tab) {
              return [
                _c(tab.component, {
                  key: tab.key,
                  tag: "component",
                  attrs: {
                    param: _vm.popupParam,
                    disabledAppr: true,
                    workPlanDatas: _vm.workPlanDatas,
                    disabledObj: _vm.disabledObj,
                  },
                  on: {
                    "update:param": function ($event) {
                      _vm.popupParam = $event
                    },
                    "update:workPlanDatas": function ($event) {
                      _vm.workPlanDatas = $event
                    },
                    "update:work-plan-datas": function ($event) {
                      _vm.workPlanDatas = $event
                    },
                    "update:disabledObj": function ($event) {
                      _vm.disabledObj = $event
                    },
                    "update:disabled-obj": function ($event) {
                      _vm.disabledObj = $event
                    },
                    disabledSet: _vm.disabledSet,
                    saveWorkPlan: _vm.saveWorkPlan,
                  },
                }),
              ]
            },
          },
        ]),
        model: {
          value: _vm.tab,
          callback: function ($$v) {
            _vm.tab = $$v
          },
          expression: "tab",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }